export const CHANGE_CHART_RESOLUTION = 'CHART/CHANGE_CHART_RESOLUTION';
export const CHANGE_CHART_RESOLUTION_SELECT = 'CHART/CHANGE_CHART_RESOLUTION_SELECT';

export const CHANGE_DISPLAY_CLOSED_ORDERS_FLAG = 'CHART/CHANGE_DISPLAY_CLOSED_ORDERS_FLAG';
export const CHANGE_DISPLAY_NEW_ORDERS_FLAG = 'CHART/CHANGE_DISPLAY_NEW_ORDERS_FLAG';
export const CHANGE_DISPLAY_POSITIONS_FLAG = 'CHART/CHANGE_DISPLAY_POSITIONS_FLAG';
export const TOGGLE_DISPLAY_POSITIONS_FLAG = 'CHART/TOGGLE_DISPLAY_POSITIONS_FLAG';
export const TOGGLE_DISPLAY_NEW_ORDERS_FLAG = 'CHART/TOGGLE_DISPLAY_NEW_ORDERS_FLAG';
export const TOGGLE_DISPLAY_CLOSED_ORDERS_FLAG = 'CHART/TOGGLE_DISPLAY_CLOSED_ORDERS_FLAG';
